module.exports = __webpack_public_path__ + "static/img/101.78c7788.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/101.png
// module id = 487
// module chunks = 3